import React from 'react';
import { useLocation } from 'react-router-dom';
import { I18n } from 'i18n';
import { useSelector } from 'react-redux';
import { Layout } from 'antd';
import { Sider, Main } from '../components';
import { Log } from '../../filter-tank-level/views/log';
import { HistoricLog } from '../../filter-tank-level/views/historic-log';

const ROUTES = [
  {
    key: 'daily-graph',
    name: I18n('daily_graph', true),
    path: '/water-quality/filter-tank-level/daily-graph',
    component: HistoricLog,
  },
  {
    key: 'table',
    name: I18n('data_table', true),
    path: '/water-quality/filter-tank-level/table',
    component: Log,
  },
];

export function FilterTankLevel() {
  const { collapseNav } = useSelector(({ app }) => app);
  const { pathname } = useLocation();
  const location = pathname.split('/');
  return (
    <Layout>
      {!collapseNav && (
        <Sider
          ROUTES={ROUTES}
          defaultSelectedKeys={location[3]}
          title={I18n('filter_tank_level', true)}
          key={'filter-tank-level'}
        />
      )}
      <Main ROUTES={ROUTES} collapseNav={collapseNav} breadcrumb={location} />
    </Layout>
  );
}
